/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildDto } from '../../models/child-dto';

export interface UserChildControllerFindByParentEmail$Params {
  parentEmail: string;
}

export function userChildControllerFindByParentEmail(http: HttpClient, rootUrl: string, params: UserChildControllerFindByParentEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChildDto>>> {
  const rb = new RequestBuilder(rootUrl, userChildControllerFindByParentEmail.PATH, 'get');
  if (params) {
    rb.query('parentEmail', params.parentEmail, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChildDto>>;
    })
  );
}

userChildControllerFindByParentEmail.PATH = '/api/child/user/my-children';
